import React from "react";
import NumberFormat from "react-number-format";
import _ from "lodash";

class InvDetail extends React.Component {
  state = { infos: {}, details: [] };

  componentDidUpdate() {
    this.state.infos !== this.props.datas &&
      this.setState({ infos: this.props.datas });
    this.state.details !== this.props.details &&
      this.setState({ details: this.props.details });
  }

  formatMoney = val => {
    return (
      <NumberFormat
        value={val}
        displayType={"text"}
        thousandSeparator={true}
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={"$"}
      />
    );
  };

  formatRate = val => {
    return (
      <NumberFormat
        value={val * 100}
        displayType={"text"}
        thousandSeparator={true}
        decimalScale={3}
        fixedDecimalScale={true}
        suffix={"%"}
      />
    );
  };

  shipPrice = (mode, val) => {
    return mode === "view" ?
      <>
        <tr>
          <td className="right aligned">
            <h4>ESTIMATED TOTAL</h4>
          </td>
          <td className="right aligned">
            <h4>{this.formatMoney(val.grandTotal)}</h4>
          </td>
        </tr>
      </>
      :
      <>
        <tr>
          <td className="right aligned">SHIP TOTAL</td>
          <td className="right aligned">
            {this.formatMoney(val.shipPrice)}
          </td>
        </tr>
        <tr>
          <td className="right aligned">
            <h4>TOTAL</h4>
          </td>
          <td className="right aligned">
            <h4>{this.formatMoney(val.grandTotal)}</h4>
          </td>
        </tr>
      </>
  }

  render() {
    const val = this.state.infos;
    const temp = this.state.details;
    const details = temp.filter(item => item.itemDesc !== 'SUBTOTAL' && item.itemDesc !== 'DISCRATE' && item.itemDesc !== 'DISCAMT');


    if (this.props.mode === "view") {
      const subt = temp.find(item => item.itemDesc === 'SUBTOTAL');
      const discRate = temp.find(item => item.itemDesc === 'DISCRATE');
      const discAmt = temp.find(item => item.itemDesc === 'DISCAMT');
      val.subTotal = subt ? subt.itemPrice : 0;
      val.discRate = discRate ? discRate.itemPrice : 0;
      val.discAmt = discAmt ? discAmt.itemPrice : 0;
      val.grandTotal = val.subTotal - val.discAmt;
    }

    const message = _.split(val.instruction,"[");
    // const sampleData = [
    //   {
    // "key": 1,
    // "itemDesc": "RIGHT LENS",
    // "itemPrice": 24.5,
    // "itemQty": 1,
    // "itemTaxable": "y"
    //   }
    // ];
    return (
      <div className="ui basic segment">
        <div className="sixteen wide field">
          <table className="ui celled compact table">
            <thead>
              <tr>
                <th>Tint Information</th>
                <th>Edge Treatment</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{val.tint+':'+val.tintOther}</td>
                <td>{val.edgeTreatment}</td>
              </tr>
            </tbody>
          </table>
          <table className="ui compact celled table">
            <tbody>
              <tr>
                <td className="tree wide active">Job Instruction</td>
                <td className="thirteen wide">{message[0]}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <table className="ui compact celled table">
          <thead>
            <tr>
              <th className="one wide center aligned">NO</th>
              <th className="eleven wide center aligned">ITEM DESCRIPTION</th>
              <th className="one wide center aligned">QTY</th>
              <th className="one wide center aligned">TAXABLE</th>
              <th className="two wide center aligned">TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {details.map(item => {
              return (
                <tr key={item.key}>
                  <td className="center aligned">{item.key}</td>
                  <td>{item.itemDesc}</td>
                  <td className="center aligned">{item.itemQty}</td>
                  <td className="center aligned">{item.itemTaxable}</td>
                  <td className="right aligned">
                    {this.formatMoney(item.itemPrice)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <table className="ui very basic compact table">
          <tbody>
            <tr>
              <td className="eleven wide top aligned" rowSpan="5">
                <div className="ui message">
                  <div className="header">{val.specialMemo}</div>
                </div>
              </td>
              <td className="three wide right aligned">SUB TOTAL</td>
              <td className="two wide right aligned">
                {this.formatMoney(val.subTotal)}
              </td>
            </tr>
            <tr>
              <td className="right aligned">DISCOUNT</td>
              <td className="right aligned">
                {this.formatMoney(val.discount)}
              </td>
            </tr>
            <tr>
              <td className="right aligned">
                SALES TAX ({this.formatRate(val.taxRate)})
              </td>
              <td className="right aligned">
                {this.formatMoney(val.taxAmount)}
              </td>
            </tr>

            {this.shipPrice(this.props.mode, val)}

          </tbody>
        </table>
      </div>
    );
  }
}

export default InvDetail;
